import { useMemo } from "react";

import { useAppSelector } from "../redux/store";
import { isReadOnlyForTenant } from "../utils/tenantUtils";

export const useReadOnlyAccess = () => {
	const { user } = useAppSelector((state) => state.user);
	const { activeTenant } = useAppSelector(
		(state) => state.tenant
	);

	return useMemo(
		() => isReadOnlyForTenant(user, activeTenant),
		[user, activeTenant]
	);
};
